const activeFilter = {
    Active: 0,
    Inactive: 1,
    Both: 2
}

export default activeFilter